<div class="main-container" *ngIf="!isLoading" data-cy="claim-log">
  <div class="section-header" data-cy="claim-log-header">
    <div class="section-header-title" data-cy="claim-log-title">View Claim Log</div>
  </div>
  <div style="flex: 1; overflow-y: auto; height: 500px; margin-top: 2px; padding: 0px 10px 10px 10px" data-cy="claim-log-content">
    <tdo-table [dataSource]="dataClaimLogs"
               [isMultiSelection]="true" [isSearchable]="true" [isUsePaginator]="true"
               [searchPredicate]="searchPredicate" (rowSelected)="onRowSelected($event)" data-cy="claim-log-table">

      <tdo-table-column displayName="Log Date/Time" propertyName="xauditCreatedOn" isSortable="true" [rowTemplate]="datetime" data-cy="claim-log-column-datetime">
        <ng-template #datetime let-row>
          <div *ngIf="row.model.xauditCreatedOn" data-cy="claim-log-cell-datetime">{{ row.model.xauditCreatedOn | date: 'medium' }}</div>
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="Type" propertyName="enumARClaimLogID" isSortable="true" [rowTemplate]="type" data-cy="claim-log-column-type">
        <ng-template #type let-row>
          <div *ngIf="row.model.enumARClaimLogID" data-cy="claim-log-cell-type">{{ this.returnARClaimLogEnum(row.model.enumARClaimLogID) }}</div>
        </ng-template>
      </tdo-table-column>
      <tdo-table-column displayName="Log Content" propertyName="LogText" isSortable="true" [rowTemplate]="content" data-cy="claim-log-column-content">
        <ng-template #content let-row>
          <div *ngIf="row.model.LogText" data-cy="claim-log-cell-content">{{ row.model.LogText }}</div>
        </ng-template>
      </tdo-table-column>

    </tdo-table>
  </div>

  <div style="flex: 1; text-align: right; padding-right:10px" data-cy="claim-log-actions">
    <button style="margin-right: 12px;" class="tdo-button warn" (click)="closeRef()" data-cy="claim-log-close-btn">Close</button>
  </div>
</div>
<div class="spinner-container" *ngIf="isLoading" data-cy="claim-log-spinner-container">
  <mat-spinner data-cy="claim-log-spinner"></mat-spinner>
</div>

